import React from 'react'
import CloseIcon from './../Icons/CloseIcon';

const CreateTeamsPopup = ({ model, handleChange, closePopup }) => {

    return (
        <div className='fixed top-0 left-0 right-0 z-20 flex items-center justify-center h-full overflow-x-hidden overflow-y-auto bg-zinc-800/90'>
            <div class="mx-auto flex max-w-[300px] flex-col rounded-lg border border-zinc-800 bg-zinc-900 p-4 text-sm text-zinc-400">
                <p class="mb-2 flex justify-between">Enter Name for the team
                    <span className='cursor-pointer ' onClick={closePopup}>
                        <CloseIcon color='#3f3f3f' />
                    </span>
                </p>
                <input
                    onChange={handleChange}
                    name='duration'
                    placeholder="Duration in minutes"
                    type="number"
                    class="mb-3 w-full rounded-md border-none bg-zinc-800 p-2 text-left font-normal placeholder-zinc-600 outline-none"
                    value={model.duration}
                />
                <p class="mb-2 flex justify-between">What is your timezone?
                    <span className='cursor-pointer ' onClick={closePopup}>

                    </span>
                </p>
                <input
                    onChange={handleChange}
                    name='duration'
                    placeholder="Duration in minutes"
                    type="number"
                    class="mb-3 w-full rounded-md border-none bg-zinc-800 p-2 text-left font-normal placeholder-zinc-600 outline-none"
                    value={model.duration}
                />

                <div class="flex flex-row gap-4">
                    <div>
                        <p class="mb-2">Working hours from</p>
                        <input
                            onChange={handleChange}
                            name='shortBreak'
                            placeholder="Minutes"
                            type="number"
                            class="mb-3 w-full rounded-md border-none bg-zinc-800 p-2 text-left font-normal placeholder-zinc-600 outline-none"
                            value={model.shortBreak} />
                    </div>
                    <div>
                        <p class="mb-2">Working hours to</p>
                        <input
                            onChange={handleChange}
                            name='longBreak'
                            placeholder="Minutes"
                            type="number"
                            class="mb-5 w-full rounded-md border-none bg-zinc-800 p-2 text-left font-normal placeholder-zinc-600 outline-none"
                            value={model.longBreak}
                        />
                    </div>
                </div>
                <button
                    onClick={closePopup}
                    type="submit"
                    class="w-full rounded-md bg-zinc-700 py-2 text-center text-sm text-zinc-300 outline-none hover:bg-zinc-600 hover:text-zinc-200 focus:bg-zinc-600 focus:ring-0">
                    Create Team
                </button>
            </div>
        </div>
    )
}

export default CreateTeamsPopup